import { render, staticRenderFns } from "./DeveloperIaaData.vue?vue&type=template&id=644e1c78&scoped=true&"
import script from "./DeveloperIaaData.vue?vue&type=script&lang=js&"
export * from "./DeveloperIaaData.vue?vue&type=script&lang=js&"
import style0 from "./DeveloperIaaData.vue?vue&type=style&index=0&id=644e1c78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644e1c78",
  null
  
)

export default component.exports